import { Injectable } from '@angular/core';
import { FenceResultAudienceComponent } from '@app/components/fence-result-audience/fence-result-audience.component';
import { RaceResultComponent } from '@app/components/race-result/race-result.component';
import { FinishComponent } from '@app/components/finish/finish.component';
import { StartComponent } from '@app/components/start/start.component';
import { FenseResultComponent } from '@app/components/fense-result/fense-result.component';
import { AdminRaceComponent } from '@app/components/admin/race/admin-race.component';
import { TrackMapComponent } from '@app/components/track-map/track-map.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { LandingComponent } from '@app/components/landing/landing.component';
import { ClientEventListnerComponent } from '@app/components/admin/client-event-listner/client-event-listner.component';
import { ManagerComponent } from '@app/components/manager/manager.component';

@Injectable({
  providedIn: 'root'
})
export class ComponentNameService {

  private componentNameMap = new Map<string, string>();
  private currentComponentNameSubject = new BehaviorSubject<string>(null);
  public currentComponentName$: Observable<string> = this.currentComponentNameSubject.asObservable();

  set currentComponentName(componentName: string) {
    this.currentComponentNameSubject.next(this.getDisplayname(componentName));
  }

  constructor() {
    this.componentNameMap.set(LandingComponent.name, '');
    this.componentNameMap.set(FenceResultAudienceComponent.name, '');
    this.componentNameMap.set(RaceResultComponent.name, 'Resultat');
    this.componentNameMap.set(FinishComponent.name, 'Målgång');
    this.componentNameMap.set(StartComponent.name, 'Start');
    this.componentNameMap.set(FenseResultComponent.name, 'Hinderbedömning');
    this.componentNameMap.set(AdminRaceComponent.name, 'Admin?');
    this.componentNameMap.set(TrackMapComponent.name, 'Bankarta');
    this.componentNameMap.set(ClientEventListnerComponent.name, 'Client events');
    this.componentNameMap.set(ManagerComponent.name, 'Arrangör');
  }

  public getDisplayname(componentName: string): string {
    if(componentName &&  this.componentNameMap.has(componentName)) {
      return this.componentNameMap.get(componentName);
    }
    return undefined;
  }

}
